const Stage = {

    // FIELDS
    "name": "Name",
    "status": "Status",
    "priority": "Priority",
    "search": "Search",

    // PAGE HEADER
    "stage": "Stage",

    // ERROR
    "error_name": "Enter Name",
    "error_status": "Select Status",
    "error_priority_positive": "Priority Should be Positive",
    "error_priority_required": "Enter Priority",
    "error_priority_type_error": "Enter only Number",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_priority": "PRIORITY",
    "table_status": "STATUS",

}

export default Stage;